import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Table from "react-bootstrap/Table";
import { UserLink } from "../util/Links";
import { ShiftTableTitle } from "./ShiftTableTitle";

const ShiftAvailabilityMatchesElement = ({ shift }) => {
  const { authAxios } = useAuth();
  const { shiftId } = useParams();
  const [loading, setLoading] = useState(true);
  const [availability, setAvailability] = useState(null);

  useEffect(() => {
    fetch();
  }, [shift]);

  const fetch = async () => {
    try {
      setLoading(true);

      var params = {
        id: shift?.id,
      };

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: params,
      };

      const response = await authAxios().get(
        "/api/backoffice/shifts/availability_matches",
        config,
      );
      setLoading(false);

      setAvailability(response.data);
    } catch (error) {
      // dont bother error handling this case
    }
  };

  if (shift === null || shift === undefined) return;
  if (shift?.status !== "OPEN") return;
  if (availability === null || availability === undefined) return;
  if (availability.length == 0) return;

  return (
    <Fragment>
      <ShiftTableTitle title={"Shift Availability Matches"} />
      <Table striped hover responsive>
        <thead>
          <tr>
            <th>Nurse</th>
            <th>Role</th>
            <th>Email</th>
            <th>Telephone</th>
          </tr>
        </thead>
        <tbody>
          {availability.map((available) => (
            <tr key={available?.id}>
              <td>{UserLink(available?.user)}</td>
              <td>{available?.user?.roles}</td>
              <td>{available?.user?.email}</td>
              <td>{available?.user?.telephone}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Fragment>
  );
};

export default ShiftAvailabilityMatchesElement;
